
import {Vue, Component, Prop} from "vue-property-decorator";
import {Datetime} from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";

@Component({
    components: {
        Datetime,
    },
})
export default class RelayExceptionalClosures extends Vue {
    @Prop({default: null})
    public closures: any;

    @Prop({default: false})
    public hasEditRight: boolean;

    private currentExceptionalClosure: any = {};
    private addExceptionalClosureDialog: boolean = false;
    private removeExceptionalClosureDialog: boolean = false;
    private creationConfirmation: string = null;

    get wording(): any {
        return {
            ok: this.$i18n.t("actions.next"),
            cancel: this.$i18n.t("actions.cancel"),
        };
    }

    get creationConfirmationWord(): string {
        return String(this.$t("relay.exceptionalClosures.add.confirmationWord"));
    }

    get validClosure(): boolean {
        return this.creationConfirmation?.toLowerCase() === this.creationConfirmationWord.toLowerCase()
            && this.currentExceptionalClosure.startDate
            && this.currentExceptionalClosure.endDate;
    }

    get exceptionalClosuresItems(): any[] {
        // Return all items for referents or admin
        // Return only future current and future items for classic users
        const closures: any[] = this.hasEditRight
            ? this.closures?.items || []
            : this.closures?.items?.filter((item) => new Date(item.endDate) > new Date()) || [];
        return closures.sort((a, b) => {
            if (new Date(a.startDate) < new Date(b.startDate)) { return -1; }
            if (new Date(a.startDate) > new Date(b.startDate)) { return 1; }
            return 0;
        });
    }

    private isPassedClosure(closure: any): boolean {
        return new Date() > new Date(closure?.endDate);
    }

    private isCurrentClosure(closure: any): boolean {
        return new Date() > new Date(closure?.startDate) && new Date() < new Date(closure?.endDate);
    }

    private reset(): void {
        this.currentExceptionalClosure = {};
        this.addExceptionalClosureDialog = false;
        this.removeExceptionalClosureDialog = false;
        this.creationConfirmation = null;
    }

    private addExceptionalClosure(): void {
        this.$emit("add-closure", this.currentExceptionalClosure);
        this.reset();
    }

    private openRemoveExceptionalClosure(item: any): void {
        this.currentExceptionalClosure = item;
        this.removeExceptionalClosureDialog = true;
    }

    private removeExceptionalClosure(): void {
        this.$emit("remove-closure", this.currentExceptionalClosure);
        this.reset();
    }
}
